import { createSearchParams } from 'react-router-dom'
import {
  ICreateBookingRequest,
  ICreateBookingResponse,
  IHotelAvailability,
  IHotelInfo,
  IHotelReservationInfo,
  ISearchAvailabilityQuery,
} from '../types/hotelTypes'
import httpClient from './httpClient'
import { IDeviceInfo } from '../types/device'

export const getHotelList = (): Promise<IHotelInfo[]> => httpClient.get('/hotels')
export const getHotelById = (hotelId: number | string): Promise<IHotelInfo> => httpClient.get(`/hotels/${hotelId}`)
export const getHotelReservation = (
  hotelId: number | string,
  reservationId: number | string,
): Promise<IHotelReservationInfo> => httpClient.get(`/hotels/${hotelId}/reservation/${reservationId}`)

export const searchAvailability = (
  hotelId: number | string,
  query: ISearchAvailabilityQuery,
): Promise<IHotelAvailability[]> => {
  const queryStr = createSearchParams([
    ['from', query.from],
    ['to', query.to],
    ['priceOption', query.priceOption],
  ])
  return httpClient.get(`/hotels/${hotelId}/availability?${queryStr}`)
}

export const createBooking = (
  hotelId: number | string,
  request: ICreateBookingRequest,
): Promise<ICreateBookingResponse> => {
  return httpClient.post(`/hotels/${hotelId}/booking`, request)
}

export const getHotelDevices = (hotelId: number | string): Promise<IDeviceInfo[]> =>
  httpClient.get(`/hotels/${hotelId}/devices`)
